'use client';

import { Box } from '@/components/ui';
import CookieBanner from '@/components/cookie-banner/cookie-banner';
import { ScrollProgress, useScrollProgress } from '@/components/animate/scroll-progress';

import sectionGenerators from '@/containers/generators';

interface Section {
  technicalName: string;
  [key: string]: any;
}

export function PageView({ data, className = '' }: { data: Section[]; className?: string }) {
  const pageProgress = useScrollProgress();

  return (
    <Box className={`overflow-x-hidden ${className}`}>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        className="fixed top-0 z-50 "
      />

      {data?.map((section: Section, key: number) => {
        const Generator = sectionGenerators[section.technicalName];

        if (!Generator) {
          return null;
        }

        // Render the dynamically generated component
        return <Generator key={key} {...section} />;
      })}
      <CookieBanner />
    </Box>
  );
}
